import { Flex, FlexProps, Text, TextProps } from '@chakra-ui/react'
import { colors } from '@hb/shared'

export const BoxHeader = ({ children, ...props }: FlexProps & TextProps) => {
  const Container = typeof children === 'string' ? Text : Flex
  return (
    <Container
      fontFamily="Hero-New"
      fontSize="xl"
      color={colors.green.hex}
      px={0}
      fontWeight={500}
      {...props}>
      {children}
    </Container>
  )
}

export const BoxSubheader = ({ children, ...props }: FlexProps & TextProps) => {
  const Container = typeof children === 'string' ? Text : Flex
  return (
    <Container fontFamily="Hero-New" fontSize="lg" opacity={0.9} {...props}>
      {children}
    </Container>
  )
}

export const BoxSubheader2 = ({ children, ...props }: FlexProps & TextProps) => {
  const Container = typeof children === 'string' ? Text : Flex
  return (
    <Container fontWeight={500} color="gray.600" fontFamily="Open Sans" {...props}>
      {children}
    </Container>
  )
}
